// extracted by mini-css-extract-plugin
export default {"-large":"_ln5PhDVk6EgPW0junYu","text":"PRhIv4GV9u7gKo2EGR25","noWrap":"qJDdLXwsMO6Cz6DGZtuI","wrapText":"PKbgvcHHY8FcKUHiEP31","inputCounter":"kNbRCopW9CDW0VOcnsO_"};